import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Toast from "../Toast/Toast";
import "./ShareButton.css";

function ShareButton() {
  const location = useLocation();
  const [pageUrl, setPageUrl] = useState("");
  const [pageTitle, setPageTitle] = useState("AAM School");
  const [toastMessage, setToastMessage] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    setPageUrl(window.location.href);
    setPageTitle(document.title || "AAM School");
    setMenuOpen(false);
  }, [location]);

  const encodedPageUrl = encodeURIComponent(pageUrl);
  const encodedTitle = encodeURIComponent(`Check out this page on AAM School: ${pageTitle}`);

  const shareLinks = [
    {
      key: "facebook",
      label: "Facebook",
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodedPageUrl}`,
    },
    {
      key: "whatsapp",
      label: "WhatsApp",
      href: `https://wa.me/?text=${encodedTitle}%20${encodedPageUrl}`,
    },
    {
      key: "telegram",
      label: "Telegram",
      href: `https://t.me/share/url?url=${encodedPageUrl}&text=${encodedTitle}`,
    },
  ];

  const handleShare = async () => {
    if (!pageUrl) {
      return;
    }

    const shareData = {
      title: pageTitle,
      text: "Check out this page on AAM School",
      url: pageUrl,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
        setMenuOpen(false);
        return;
      }

      setMenuOpen((current) => !current);
    } catch (error) {
      if (error?.name === "AbortError") {
        return;
      }

      setMenuOpen((current) => !current);
    }
  };

  const handleCopyLink = async () => {
    if (!pageUrl) {
      return;
    }

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(pageUrl);
        setToastMessage("Current page link copied to clipboard.");
        setMenuOpen(false);
        return;
      }

      throw new Error("Clipboard not supported");
    } catch (error) {
      const copied = window.prompt("Copy this link:", pageUrl);
      if (copied !== null) {
        setToastMessage("Current page link is ready to copy.");
        setMenuOpen(false);
      }
    }
  };

  return (
    <>
      <div className="global-share-wrap">
        <button
          type="button"
          className="global-share-button"
          onClick={handleShare}
          aria-label="Share this page"
          aria-expanded={menuOpen}
        >
          Share
        </button>

        {menuOpen ? (
          <div className="global-share-menu" role="menu" aria-label="Share options">
            {shareLinks.map((item) => (
              <a
                key={item.key}
                className="global-share-link"
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                role="menuitem"
              >
                {item.label}
              </a>
            ))}
            <button
              type="button"
              className="global-share-link global-share-copy"
              onClick={handleCopyLink}
              role="menuitem"
            >
              Copy Link
            </button>
          </div>
        ) : null}
      </div>
      <Toast message={toastMessage} onClose={() => setToastMessage("")} />
    </>
  );
}

export default ShareButton;
